import { useState } from 'react'
import { FileText, Plus } from 'lucide-react'
import { TemplateList } from '@components/templates/TemplateList'
import { TemplateEditor } from '@components/templates/TemplateEditor'
import { TemplatePreview } from '@components/templates/TemplatePreview'
import { Template } from '@/types'

export function TemplatesPage() {
  const [showEditor, setShowEditor] = useState(false)
  const [editingTemplate, setEditingTemplate] = useState<Template | null>(null)
  const [showPreview, setShowPreview] = useState(false)
  const [previewTemplate, setPreviewTemplate] = useState<Template | null>(null)

  const handleEdit = (template: Template) => {
    setEditingTemplate(template)
    setShowEditor(true)
  }

  const handlePreview = (template: Template) => {
    setPreviewTemplate(template)
    setShowPreview(true)
  }

  const handleTest = (template: Template) => {
    setEditingTemplate(template)
    setShowEditor(true)
  }

  const handleCloseEditor = () => {
    setShowEditor(false)
    setEditingTemplate(null)
  }

  const handleEditorSuccess = () => {
    // Editor will handle closing itself after success
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="icon-container icon-container-lg">
            <FileText size={24} className="text-cyan-500" />
          </div>
          <h1 className="text-3xl font-bold text-slate-100">Templates</h1>
        </div>
        <button
          onClick={() => {
            setEditingTemplate(null)
            setShowEditor(true)
          }}
          className="btn-primary"
        >
          <Plus size={20} />
          New Template
        </button>
      </div>

      <TemplateList
        onEdit={handleEdit}
        onPreview={handlePreview}
        onTest={handleTest}
      />

      {showEditor && (
        <TemplateEditor
          template={editingTemplate}
          onClose={handleCloseEditor}
          onSuccess={handleEditorSuccess}
        />
      )}

      {showPreview && previewTemplate && (
        <TemplatePreview
          template={previewTemplate}
          onClose={() => {
            setShowPreview(false)
            setPreviewTemplate(null)
          }}
        />
      )}
    </div>
  )
}
